import { createFileRoute } from "@tanstack/react-router";
import NewHopeForChronicPainWithoutOpioidsPage from "@/pages/articles/NewHopeForChronicPainWithoutOpioidsPage";
export const Route = createFileRoute(
  "/new-hope-for-treating-chronic-pain-without-opioids-in-florida",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Chronic Pain Without Opioids in FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Discover opioid-free chronic pain treatments in Florida—IV Ketamine, TMS, and interventional therapies that target central sensitization without addiction risk.",
        },
        {
          property: "og:title",
          content: "Chronic Pain Without Opioids in FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Discover opioid-free chronic pain treatments in Florida—IV Ketamine, TMS, and interventional therapies that target central sensitization without addiction risk.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/new-hope-for-treating-chronic-pain-without-opioids-in-florida",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/new-hope-for-treating-chronic-pain-without-opioids-in-florida",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NewHopeForChronicPainWithoutOpioidsPage />;
}
